import { render, staticRenderFns } from "./SettingsImport.vue?vue&type=template&id=3ec83dd7"
import script from "./SettingsImport.vue?vue&type=script&lang=js"
export * from "./SettingsImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ec83dd7')) {
      api.createRecord('3ec83dd7', component.options)
    } else {
      api.reload('3ec83dd7', component.options)
    }
    module.hot.accept("./SettingsImport.vue?vue&type=template&id=3ec83dd7", function () {
      api.rerender('3ec83dd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/partials/SettingsImport.vue"
export default component.exports